import useSWR from 'swr';

// Utils
import { get } from '@/utils/client';
import { injectEndpointUrlParams } from '@/utils/injectEndpointUrlParams';

// Hooks
import useActiveSocialProfile from '@/hooks/user/useActiveSocialProfile';

// Routes
import { MENTIONS } from '@/routes/apiEndpoints';

// Lib

const useMentions = (options = {}) => {
    const { activeSocialProfile } = useActiveSocialProfile();
    const { data, mutate, error } = useSWR(
        injectEndpointUrlParams(MENTIONS, {
            SPID: activeSocialProfile?.id
        }),
        (url) => get(url).then((res) => res.data),
        {
            shouldRetryOnError: false,
            ...options
        }
    );

    const isLoading = !data && !error;

    return {
        data,
        min_date: data?.summary?.min_date || null,
        mutate,
        isLoading,
        error
    };
};

export default useMentions;
